<template>

  <div class="banner-slide borde-dashed">
    <div id="banner-slide-contain" tabindex="0" class="textos">
      <slot v-if="index + 1 === contenidoActual" v-for="(item, index) in numeroBotones" :name="'cont'+index"></slot>
      <button v-if="!finContenidos && (contenidoActual > 0)" @click="backMenu()" aria-label="Volver a la lista anterior"></button>
    </div>
    <div class="banner-buttons">
      <button :id="'bot-banner-slide-'+index" @click="showCont(index)" v-for="(item, index) in numeroBotones" :class="index + 1 === contenidoActual?'active':''"></button>
    </div>
  </div>

</template>
<script>
export default {
  props: {
    numeroBotones: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      contenidoActual: 0,
      finContenidos: false
    };
  },
  methods: {
    showCont(event) {
      this.contenidoActual = event + 1;
      this.botones[event].active = true;
      document.getElementById("banner-slide-contain").focus();
      var showNext = this.botones.every(elem => {
        return elem.visto === true;
      });
      if (showNext) {
        this.$store.commit("nextShow", true);
      }
      this.finContenidos = showNext;
    },
    backMenu() {
      document.getElementById("bot-banner-slide-" + this.contenidoActual).focus();
    }
  },
  computed: {
    botones() {
      var arrayBots = [];
      for (let index = 0; index < this.numeroBotones; index++) {
        arrayBots.push({
          visto: false
        });
      }
      return arrayBots;
    }
  }
};
</script>

<style lang="scss" scoped>
.banner-slide {
  width: 100%;
  max-width: 600px;
  overflow: hidden;
  margin: auto;
  .textos {
    min-height: 300px;
    padding: 10px;
    &:focus {
      outline: none;
    }
  }
  .banner-buttons {
    text-align: center;
    button {
      cursor: pointer;
      width: 16px;
      height: 16px;
      border-radius: 50%;
      background-color: #ccc;
      margin: 5px;
      &:hover {
        background-color: #666;
      }
      &.active {
        background-color: red;
      }
    }
  }
}
</style>




// WEBPACK FOOTER //
// BannerSlide.vue?bbe1c39a